import axios from '@/plugins/axios'

const getChapters = async ({
  bookId,
  page = 1
}) => {
  try {
    const response = await axios.get('chapters', {
      params: {
        book_id: bookId,
        page: page
      }
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const reorderChapter = async ({ id, orderNumber }) => {
  try {
    const params = {
      order_number: orderNumber,
      _method: 'PUT'
    }
    const response = await axios.post(`chapters/${id}/reorder`, params)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  getChapters,
  reorderChapter
}
